import { render, staticRenderFns } from "./InsightOverall.vue?vue&type=template&id=3dfa5c6f&"
import script from "./InsightOverall.vue?vue&type=script&lang=js&"
export * from "./InsightOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports